module.exports = __webpack_public_path__ + "static/media/SA.ab72250f.webp";